function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "ic-bulb_svg__a",
  width: "125%",
  height: "125%",
  x: "-12.5%",
  y: "-10.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 4
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
})), React.createElement("circle", {
  id: "ic-bulb_svg__b",
  cx: 56,
  cy: 56,
  r: 56
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0-2h130v130H0z"
}), React.createElement("g", {
  transform: "translate(9 7)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#ic-bulb_svg__a)",
  xlinkHref: "#ic-bulb_svg__b"
}), React.createElement("use", {
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2,
  xlinkHref: "#ic-bulb_svg__b"
})), React.createElement("path", {
  d: "M29 27h72v72H29z"
}), React.createElement("g", {
  stroke: "#12123B"
}, React.createElement("path", {
  strokeWidth: 2,
  d: "M65.5 47.68c9.938 0 14.354 7.66 14.354 12.037 0 7.113-6.625 10.943-6.625 16.415v7.66H57.771v-7.66c0-5.472-6.625-9.302-6.625-16.415 0-4.377 4.417-12.038 14.354-12.038z"
}), React.createElement("path", {
  strokeWidth: 3,
  d: "M57.77 78.32h15.46"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M65.5 34.547v4.378"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M79.854 44.396l4.969-4.924"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M87.583 56.434H92"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.2,
  d: "M83.167 68.472l6.625 4.377"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M51.146 44.396l-4.969-4.924"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M43.417 56.434H39"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M47.833 68.472l-6.625 4.377"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M61.083 90.358h8.834"
})), React.createElement("g", {
  transform: "translate(14.49 8.098)"
}, React.createElement("circle", {
  cx: 13.176,
  cy: 13.176,
  r: 12.176,
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2
}), React.createElement("path", {
  fill: "#12123B",
  d: "M16.485 17.257c.27 0 .474.061.614.185.14.123.21.296.21.52 0 .482-.275.723-.824.723h-6.484c-.247 0-.44-.07-.58-.21a.717.717 0 01-.21-.53c0-.257.1-.492.302-.705l3.948-4.318c.527-.57.908-1.092 1.143-1.562a3.1 3.1 0 00.353-1.394c0-.594-.171-1.05-.513-1.37-.341-.319-.826-.478-1.453-.478-.952 0-1.898.364-2.84 1.092a2.854 2.854 0 01-.31.176.61.61 0 01-.26.059c-.157 0-.292-.073-.404-.219a.83.83 0 01-.168-.52c0-.28.112-.504.336-.672a5.438 5.438 0 011.697-.966 5.801 5.801 0 012-.362c1.108 0 1.99.283 2.645.849.656.565.983 1.33.983 2.293 0 .683-.148 1.333-.445 1.949-.297.616-.792 1.305-1.487 2.066l-3.175 3.394h4.922z"
})));

var SvgIcBulb = function SvgIcBulb(props) {
  return React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcBulb as ReactComponent };